import { CLOSE_OPENED_PROPERTY } from '../constants';

export const actionCloseOpenedProperty = () => {
  return async dispatch => {
    dispatch({ type: CLOSE_OPENED_PROPERTY });
  };
};

export default actionCloseOpenedProperty;
